module.exports = __webpack_public_path__ + "media/body-condition/cavapoo-just-right-134cd5e2.svg";